const asObject = (value) => value && typeof value === 'object' && !Array.isArray(value)
  ? value : null;

const protocolNumber = (value) => {
  if (value == null) return null;
  const number = Number(value);
  return Number.isSafeInteger(number) && number >= 0 ? number : null;
};

// The socket transport owns connections; this adapter owns the wire contract. Invalid frames
// are rejected before they can reach reducers, and server stateVersion is the only ordering
// authority (timestamps remain presentation data).
export const decodeRoomEvent = (body, expectedRoomId) => {
  let parsed;
  try {
    parsed = typeof body === 'string' ? JSON.parse(body) : body;
  } catch (_) {
    return { error: 'invalid-json' };
  }
  const envelope = asObject(parsed);
  const payload = asObject(envelope?.payload);
  if (!envelope || typeof envelope.type !== 'string' || !payload) {
    return { error: 'invalid-envelope' };
  }
  const wireRoomId = payload.roomId ?? envelope.roomId;
  if (wireRoomId != null && String(wireRoomId) !== String(expectedRoomId)) {
    return { error: 'wrong-room' };
  }
  const rawStateVersion = payload.stateVersion ?? envelope.stateVersion;
  const rawEventVersion = payload.eventVersion ?? envelope.eventVersion;
  const rawHandId = payload.handId ?? envelope.handId;
  const handId = protocolNumber(rawHandId);
  const stateVersion = protocolNumber(rawStateVersion);
  const eventVersion = protocolNumber(rawEventVersion);
  if ((rawHandId != null && handId == null)
      || (rawStateVersion != null && stateVersion == null)
      || (rawEventVersion != null && eventVersion == null)) {
    return { error: 'invalid-version' };
  }
  const eventId = envelope.eventId ?? payload.eventId ?? null;
  if (eventId != null && typeof eventId !== 'string') return { error: 'invalid-event-id' };
  return {
    event: envelope,
    protocol: Object.fromEntries(Object.entries({
      handId,
      stateVersion,
      eventVersion,
      eventId,
    }).filter(([, value]) => value != null)),
  };
};

export const isOlderRoomEvent = (currentGame, protocol) => {
  const current = protocolNumber(currentGame?.stateVersion);
  const incoming = protocolNumber(protocol?.stateVersion);
  return current != null && incoming != null && incoming < current;
};
